export enum CommentsoldIntegrationProduct {
  RETURNS = "returns",
  OMS = "oms",
  MARKETING = "marketing",
}

/**
 * CommentSold Event Types Enum
 */
export enum CommentSoldMarketingEventType {
  PAGE_VIEW = "customer.page_view",
  ADD_TO_CART = "customer.cart.add",
  REMOVE_FROM_CART = "customer.cart.remove",
  CHECKOUT_STARTED = "customer.checkout.started",
  CHECKOUT_COMPLETED = "customer.checkout.completed",
  CUSTOMER_INFO_UPDATED = "customer.info.updated",
  INVENTORY_UPDATED = "shop.inventory.updated",
}

export function isCommentSoldMarketingEventType(
  eventType: string,
): eventType is CommentSoldMarketingEventType {
  return Object.values(CommentSoldMarketingEventType).includes(
    eventType as CommentSoldMarketingEventType,
  );
}
